import { ROLES, SCOPES } from './permissions.constants';

import type { UserPermissionType } from './permissions.types';

export const PERMISSIONS: UserPermissionType = {
  [ROLES.super_user]: [
    SCOPES.canView,
    SCOPES.canEdit,
    SCOPES.canCreate,
    SCOPES.canDelete,
  ],
  [ROLES.owner]: [
    SCOPES.canView,
    SCOPES.canEdit,
    SCOPES.canCreate,
    SCOPES.canDelete,
  ],
  [ROLES.administrator]: [
    SCOPES.canView,
    SCOPES.canEdit,
    SCOPES.canCreate,
    SCOPES.canDelete,
  ],
  [ROLES.user]: [
    SCOPES.canView,
    SCOPES.canEdit,
    SCOPES.canCreate,
    SCOPES.canDelete,
  ],
  [ROLES.applier]: [
    SCOPES.canView,
    SCOPES.canEdit,
    SCOPES.canCreate,
    SCOPES.canDelete,
  ],
  [ROLES.reporter]: [
    SCOPES.canView,
    SCOPES.canEdit,
    SCOPES.canCreate,
    SCOPES.canDelete,
  ],
  [ROLES.viewer]: [SCOPES.canView],
  [ROLES.unset]: [],
  UNSET: [],
};
